import React, { useState, useEffect } from 'react';
import MobileIdentifier from '../../../atoms/mobile-identifier/MobileIdentifier';
import CommentCard from '../../../molecules/comments/comment-card/CommentCard';
import LongCard from '../../../molecules/comments/comment-card/LongCard';
import CommentBannerPositioner from './CommentBannerPositioner';
import Utils from '../../../../utils/comments-utils';
import styles from './styles.scss';
import AllCommentsModal from '../../../molecules/comments/all-comments-modal';
import CommentViewHeader from '../../../molecules/comments/comment-view-header';
import { CommentViewProps, Comment, CommentBannerData } from '../../../../utils/comments/types'
import { Grid } from '@material-ui/core';

const CommentBanner = function CommentBanner(
    { isMobile = false, targetkey, appealurl, appealname, favicon, isSmallScreen = false, charitykey }: CommentViewProps
) {
    const [sortType, setSortType] = useState(Utils.SortOrders.Newest.Key);
    const [commentData, setCommentData] = useState<CommentBannerData>({ count: 0, list: [] });
    const [replies, setReplies] = useState<Array<Comment>>([]);

    const fetchComments = async () => {
        try {
            const apiRequestUrl = `/odata/messages?$apply=filter(querykey eq '${targetkey}' and (parent eq ''))&$count=true&$orderby=${Utils.GetOrderByQuery(sortType)}&$top=6`;

            const response = await fetch(apiRequestUrl);
            if (!response.ok) {
                throw new Error('Failed to fetch comments');
            }

            const json = await response.json();
            return {
                list: Utils.GetNestedComments(charitykey, json.value, appealname),
                count: json['@odata.count'],
            };
        } catch (e) {
            console.error(e);
            return commentData;
        }
    };

    const fetchReplies = async () => {
        try {
            const parents = commentData.list.map((c) => c.Key).join('\',\'');

            if (parents.length <= 0) {
                return [];
            }

            const replyRequestUrl = `/odata/messages?$apply=filter(parent in ('${parents}'))&$top=6`;

            const response = await fetch(replyRequestUrl);
            if (!response.ok) {
                throw new Error('Failed to fetch replies');
            }

            const json = await response.json();
            return json.value;
        } catch (e) {
            console.error(e);
            return [];
        }
    };

    useEffect(() => {
        const fetch = async () => setCommentData(await fetchComments());

        fetch();
    }, [sortType]);

    useEffect(() => {
        const fetch = async () => setReplies(await fetchReplies());

        fetch();
    }, [commentData]);

    return (
        <CommentBannerPositioner isMobile={isMobile}>
            <Grid className={styles['comment-banner']} container spacing={1} data-testid="comment-banner">
                <Grid item xs={12}>
                    <CommentViewHeader
                        commentCount={commentData.count}
                        sortType={sortType}
                        sortTypeCallback={(value) => setSortType(value)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={1} className={styles['comment-banner-content']}>
                        {commentData.list
                            .slice(0, isSmallScreen ? 4 : 6) // we want to show only 4 comments on small screens
                            .map((c) => (
                                <Grid item xs={12} md={6} lg={4} key={c.Key}>
                                    {
                                        isMobile
                                            ? (
                                                <LongCard
                                                    pageUrl={Utils.GetPageUrl(c.GroupPath, appealurl)}
                                                    targetName={Utils.GetTargetName(charitykey, c.TargetName, appealname)}
                                                    avatarSrc={favicon}
                                                    comment={{
                                                        ...c,
                                                        Reply: replies.find((r) => r.Parent === c.Key),
                                                    }}
                                                />
                                            )
                                            : (
                                                <CommentCard
                                                    pageUrl={Utils.GetPageUrl(c.GroupPath, appealurl)}
                                                    targetName={Utils.GetTargetName(charitykey, c.TargetName, appealname)}
                                                    avatarSrc={favicon}
                                                    comment={{
                                                        ...c,
                                                        Reply: replies.find((r) => r.Parent === c.Key),
                                                    }}
                                                    isMobile={isMobile}
                                                    
                                                />
                                            )
                                    }
                                </Grid>
                            ))}
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <AllCommentsModal charityKey={charitykey} targetKey={targetkey} isMobile={isMobile} />
                </Grid>
            </Grid>
        </CommentBannerPositioner >
    );
};

export default MobileIdentifier(CommentBanner);
